module.exports = __webpack_public_path__ + "static/media/Smartphone.d2d5eae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/Smartphone.png
// module id = 803
// module chunks = 1 3